import { render } from "./Store1.vue?vue&type=template&id=d35f43d2&scoped=true"
import script from "./Store1.vue?vue&type=script&lang=js"
export * from "./Store1.vue?vue&type=script&lang=js"

import "./Store1.vue?vue&type=style&index=0&id=d35f43d2&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35f43d2"]])

export default __exports__